import { HealthcareBasicData } from '../../../common/HealthcareBasicData';

import { HealthcareFacilityUnitTreeItem } from './HealthcareFacilityUnitTreeItem';
import { HealthcareFacilityUnitTreeItemsLoader } from './HealthcareFacilityUnitTreeItems.loader';

type HealthcareFacilityUnitTreeItemsProps = {
   readonly healthcareParentData: HealthcareBasicData;
};

export const HealthcareFacilityUnitTreeItems = (props: HealthcareFacilityUnitTreeItemsProps): JSX.Element => {
   return (
      <HealthcareFacilityUnitTreeItemsLoader healthcareParentData={props.healthcareParentData}>
         {({ healthcareFacilityUnits, refetchHealthcareFacilityUnits }) => (
            <>
               {healthcareFacilityUnits.map((healthcareFacilityUnit) => (
                  <HealthcareFacilityUnitTreeItem
                     key={healthcareFacilityUnit.id}
                     healthcareFacilityUnit={healthcareFacilityUnit}
                     healthcareParentData={props.healthcareParentData}
                     onDataChanged={refetchHealthcareFacilityUnits}
                  />
               ))}
            </>
         )}
      </HealthcareFacilityUnitTreeItemsLoader>
   );
};
